// extracted by mini-css-extract-plugin
export default {"row":"styles_row__7S8L0","col-name":"styles_col-name__WBjPm"};